import { render, staticRenderFns } from "./EditKeyword.vue?vue&type=template&id=29c9caa5&scoped=true"
import script from "./EditKeyword.vue?vue&type=script&lang=js"
export * from "./EditKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c9caa5",
  null
  
)

export default component.exports